import { createApiAction } from '@app/packages/api/utils'
import type { ApiPlan } from '@app/packages/api/v2/types/entities'

export const getPlans = () => createApiAction('getPlans', dispatch => dispatch<{ data: ApiPlan[] }>({ method: 'GET', endpoint: '/api/v2/plans' }))
